import React from 'react';
import { MobileTable } from './MobileTable';
import { TermOptionsTableStyle } from '../styles';
import { useSlideData } from '@context/slide-data';

export const TermOptionsTable = ({ data, cellColor }) => {
    const { desktop } = useSlideData();

    const tableHeaders = data.map(item => item.label);
    const tableValues = data.map(item => item.value);

    if (!desktop) {
        return <MobileTable data={data} background={cellColor} />
    }

    return (
        <TermOptionsTableStyle cellColor={cellColor}>
            <thead>
                <tr>
                    {
                        tableHeaders.map(header => (
                            <th key={header}>{header}</th>
                        ))
                    }
                </tr>
            </thead>
            <tbody>
                <tr>
                {
                        tableValues.map((value, index) => (
                            <td key={index}>
                                <strong>{value}</strong>
                            </td>
                        ))
                    }
                </tr>
            </tbody>
        </TermOptionsTableStyle>
    );
};

export default TermOptionsTable;
